var map = {
	"./chto-take-privivka/banner-desc.png": "7feb",
	"./chto-take-privivka/banner-mob.png": "ba2d",
	"./circle-bact.svg": "eb54",
	"./circle-brain.svg": "85e3",
	"./circle-cough.svg": "5b7b",
	"./circle-liver.svg": "0996",
	"./circle-lungs.svg": "3c32",
	"./fb.svg": "21ed",
	"./icon-cal.svg": "2a85",
	"./icon-map.svg": "75a6",
	"./infection-in-school/banner-desc.png": "19c4",
	"./infection-in-school/banner-mob.png": "d3b5",
	"./infection-in-school/bed.svg": "e8cb",
	"./infection-in-school/cashluk.png": "d4ce",
	"./infection-in-school/dod-revac.svg": "eb5f",
	"./infection-in-school/flu.svg": "d4c2",
	"./infection-in-school/grvi.svg": "ac27",
	"./infection-in-school/patch.svg": "e3f1",
	"./infection-in-school/pnev.svg": "971e",
	"./infection-in-school/posud.svg": "fb47",
	"./infection-in-school/pov-crap.svg": "602f",
	"./infection-in-school/predmety.svg": "a918",
	"./infection-in-school/spot.svg": "a2f8",
	"./infection-in-school/tap.svg": "55b8",
	"./infection-in-school/temp.svg": "8d93",
	"./infection-in-school/turbota.png": "64ef",
	"./infection-in-school/ukol.svg": "87fd",
	"./infection-in-school/ukol2.svg": "ab4b",
	"./infection-in-school/ukol3.svg": "5610",
	"./infection-in-school/ukol4.svg": "57c9",
	"./infection-in-school/ukol5.svg": "ea81",
	"./polio/banner-desc.png": "8f9e",
	"./polio/banner-mob.png": "f0ee",
	"./preparation/allergy.png": "c99d",
	"./preparation/banner-desc.png": "1d7a",
	"./preparation/banner-mob.png": "4e31",
	"./read-also-card.png": "b027",
	"./read-also-mob.png": "833b",
	"./recomendations/banner-desc.png": "c934",
	"./recomendations/banner-mob.png": "faa8",
	"./similar-pered-sad2.png": "e654",
	"./similar-pered-shkola.png": "d93e",
	"./similar-pidgotovka-do-vac.png": "419f",
	"./similar-swit-recom.png": "57df",
	"./telegram.svg": "f6f4",
	"./ua-recom/banner-desc.png": "3960",
	"./ua-recom/banner-mob.png": "3742",
	"./vac-adults/banner-desc.png": "0587",
	"./vac-adults/banner-mob.png": "e963",
	"./vac-adults/chron.svg": "fdc5",
	"./vac-adults/epid-poc.svg": "23c5",
	"./vac-adults/maternity.svg": "5449",
	"./vac-adults/prof.svg": "54d9",
	"./vac-adults/revac.svg": "59d8",
	"./vac-adults/table.svg": "84e0",
	"./vac-before-school/banner-desc.png": "4767",
	"./vac-before-school/banner-mob.png": "d18b",
	"./vac-before-school/flu.svg": "d06d",
	"./vac-before-school/gepatit.svg": "2280",
	"./vac-before-school/meningcocova.svg": "ff72",
	"./vac-before-school/pnevmococova.svg": "02bf",
	"./vac-before-school/vispa.svg": "2645",
	"./vaccination-kindergarten/banner-desc.png": "6a32",
	"./vaccination-kindergarten/banner-mob.png": "d2e1",
	"./viber.svg": "37f7",
	"./what-is-flu/banner-desc.png": "30a0",
	"./what-is-flu/banner-mob.png": "ea25",
	"./what-is-flu/icon-1.svg": "b5b5",
	"./what-is-flu/icon-2.svg": "8ce1",
	"./what-is-flu/icon-3.svg": "35f9",
	"./what-is-flu/icon-4.svg": "d17d",
	"./what-is-flu/icon-5.svg": "c06f",
	"./what-is-flu/icon-6.svg": "69c1",
	"./whatsApp.svg": "3013"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18c3";